import * as ActionTypes from '../ActionTypes';

export const GetShiftTimeConfigureAction = () => {
    return {
        type: ActionTypes.SHIFT_TIME_CONFIGURE_GET_REQUEST,
    }
}


export const AddShiftTimeConfigureAction = (params) => {
    return {
        type: ActionTypes.SHIFT_TIME_CONFIGURE_ADD_REQUEST,
        params
    }
}

export const UpdateShiftTimeConfigureAction = (params) => {
    return {
        type: ActionTypes.SHIFT_TIME_CONFIGURE_UPDATE_REQUEST,
        params
    }
}

export const DeleteShiftTimeConfigureAction = (params) => {
    return {
        type: ActionTypes.SHIFT_TIME_CONFIGURE_DELETE_REQUEST,
        params
    }
}